import React from 'react';

// Nexus Core Design System (DESIGN.md §6) - Buttons
const variants = {
  primary:
    'bg-nexus-primary text-white hover:bg-nexus-primary-container shadow-md shadow-nexus-primary/10 active:scale-[0.98]',
  secondary:
    'bg-transparent text-text-primary border border-border-light hover:bg-light-neutral active:scale-[0.98]',
  danger:
    'bg-red-500 text-white hover:bg-red-600 shadow-md shadow-red-500/10 active:scale-[0.98]',
  'danger-outline':
    'bg-transparent text-red-600 border border-red-200 hover:bg-red-50 active:scale-[0.98]',
  ghost:
    'text-text-primary hover:bg-light-neutral',
  link:
    'text-nexus-primary hover:underline px-0',
};

const sizes = {
  sm: 'h-8 px-3 text-xs gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-4 text-base gap-2',
};

const iconOnlySizes = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconOnly = false,
  disabled = false,
  loading = false,
  className = '',
  ...props
}) {
  const baseClasses =
    'inline-flex items-center justify-center font-medium rounded-lg cursor-pointer transition-all duration-150 disabled:opacity-60 disabled:cursor-not-allowed disabled:active:scale-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-nexus-primary/40';
  const variantClasses = variants[variant] || variants.primary;
  const sizeClasses = iconOnly ? iconOnlySizes[size] : sizes[size];

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      ) : (
        <>
          {icon && <span className="flex-shrink-0">{icon}</span>}
          {!iconOnly && children}
        </>
      )}
    </button>
  );
}
